/* eslint-disable no-unused-vars */
import { Controller, useWatch } from 'react-hook-form';
import * as S from '../AppInstallPostbackForm.styled';
import { CopyString, CustomInput, ToggleBtn, Separators, CustomInputAutosize } from 'components';
import { DeleteIcon } from 'assets/icons';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { CopyIcon } from 'assets/icons';
import TestBtn from './TestBtn';
import { Label } from './Label';

const Section = ({
  getValues,
  createPreview,
  errors,
  control,
  sectionName,
  title,
  children,
  fieldList,
}) => {
  const [parent] = useAutoAnimate();

  const state = useWatch({ control, name: `${sectionName}.state` });
  const sectionErrors = errors?.[sectionName];
  const isSectionValid = !sectionErrors || Object.keys(sectionErrors).length === 0;

  return (
    <div ref={parent}>
      <S.Head>{title}</S.Head>
      <S.Field style={{ paddingBottom: '32px' }}>
        <S.TextField>{children}</S.TextField>
        <Controller
          defaultValue={getValues(`${sectionName}.baseUrl`)}
          name={`${sectionName}.state`}
          control={control}
          render={(props) => {
            const {
              field: { onChange, value, name },
              fieldState: { error },
            } = props;
            const handleToggle = () => {
              if (value) {
                const baseUrl = getValues(`${sectionName}.baseUrl`) || '';
                const firstQMark = baseUrl.indexOf('?');
                if (firstQMark !== -1 && baseUrl.substring(firstQMark + 1).includes('?')) {
                  return;
                }
              }
              onChange(!value);
            };
            return <ToggleBtn id='enableField' isChecked={value} onChange={handleToggle} />;
          }}
        />
      </S.Field>
      {state && (
        <div style={{ paddingBottom: '8px' }}>
          <S.TextAriaField>
            <S.Title htmlFor={`${sectionName}.baseUrl`}>Add your Base URL:</S.Title>
            <Controller
              defaultValue={getValues(`${sectionName}.baseUrl`) ?? ''}
              name={`${sectionName}.baseUrl`}
              control={control}
              render={(props) => {
                const {
                  field: { onChange, value, name },
                  fieldState: { error },
                } = props;
                return (
                  <CustomInput
                    name={name}
                    value={value}
                    onChange={onChange}
                    id={name}
                    containerStyle={{ marginTop: '8px' }}
                    multiline={true}
                    rows={5}
                    rightIcon={value && <DeleteIcon />}
                    rightIconOnClick={() => onChange('')}
                    error={Boolean(error?.message)}
                    errorText={error?.message}
                  />
                );
              }}
            />
          </S.TextAriaField>
          {fieldList.map((fieldName) => {
            return (
              <S.Field key={`${sectionName}.${fieldName}`} style={{ marginBottom: '8px' }}>
                <Label fieldName={fieldName} />
                <Controller
                  defaultValue={getValues(`${sectionName}.${fieldName}`) || ''}
                  name={`${sectionName}.${fieldName}`}
                  control={control}
                  render={(props) => {
                    const {
                      field: { onChange, value, name },
                      fieldState: { error },
                    } = props;
                    return (
                      <CustomInput
                        value={value}
                        onChange={onChange}
                        name={name}
                        id={name}
                        rightIcon={value && <DeleteIcon />}
                        rightIconOnClick={() => onChange('')}
                        error={Boolean(error?.message)}
                        errorText={error?.message}
                      />
                    );
                  }}
                />
              </S.Field>
            );
          })}
          <Controller
            defaultValue={getValues(`${sectionName}.baseUrl`) ?? ''}
            name={`${sectionName}.baseUrl`}
            control={control}
            render={(props) => {
              const {
                field: { onChange, value, name },
                fieldState: { error },
              } = props;
              const previewURL = createPreview(useWatch({ control, name: `${sectionName}` }));
              return (
                <>
                  {previewURL && (
                    <S.TextAriaField>
                      <Separators
                        type={Separators.separatorTypes.small}
                        style={{ margin: '32px 0' }}
                      />
                      <S.TitleWrap>
                        <S.Title htmlFor='urlPreview'>Postback URL Preview:</S.Title>
                        <CopyString text={previewURL} label='' isHidden icon={<CopyIcon />} />
                      </S.TitleWrap>
                      <CustomInput
                        value={previewURL}
                        id='urlPreview'
                        name='urlPreview'
                        multiline={true}
                        rows={5}
                        onChange={() => {}}
                      />
                      <S.Footer>
                        <div>
                          <label>Send a test post to your Posback URL.</label>
                          <span>
                            Appnext will send Postbacks from one of these IP addresses:
                            54.204.84.86, 184.73.163.42 and 23.21.212.42.
                            <br /> Make sure to white-list these IP addresses.
                          </span>
                        </div>
                        <TestBtn disabled={!isSectionValid} previewURL={previewURL} />
                      </S.Footer>
                    </S.TextAriaField>
                  )}
                </>
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Section;
